//El adressId debe modificarse donde se utiliza este config 
const hardcodeDomicilioParaCompraClubExterior = {
    addressId: null,
    altura: '999',
    calle: '9999',
    cp: '0000',
    dpto: '0',
    entreCalle1: 'No Informa',
    entreCalle2: 'No Informa',
    localidad: 'No Informa',
    pais: 'ARGENTINA',
    piso: '0',
    provincia: 'CAPITAL FEDERAL',
    torre: null,
    cuerpo: null,
    lote: '',
    observaciones: null,
    tipoDePropiedad: 'CASA',
    estaHabilitada: false,
    barrio: 'No Informa',
    nombreDePropiedad: null,
    normalizada: true,
    omiteNormalizar: true
}

export default hardcodeDomicilioParaCompraClubExterior;